import styled from 'styled-components';

import colors from '../../../styles/colors';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`;

const GridWrapper = styled.div`
  flex: 1;
  min-height: 420px;
  margin: 0 20px 20px;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-top: 5px;
  flex-shrink: 0;
  white-space: nowrap;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const OverdueText = styled.span`
  color: ${({ $hasOverdue }) => ($hasOverdue ? colors.base.danger : 'inherit')};
  font-weight: ${({ $hasOverdue }) => ($hasOverdue ? 700 : 400)};
`;

// Wide enough for a CAM's name, and never squeezed by the title.
const CoachSetControl = styled.div`
  flex-shrink: 0;
  min-width: 220px;
`;

export {
  PageContainer,
  GridWrapper,
  HeaderActions,
  ActionButtons,
  OverdueText,
  CoachSetControl,
};
